export enum Status {
    Passive = 0,
    Active = 1,
    Deleted = 2,
}